import React, { useEffect, useState } from "react";
import { Container, Label } from "reactstrap";
import Modal from "react-modal"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useNavigate } from "react-router-dom";
import { Loading } from "../share/loading";
import { FiEdit } from "react-icons/fi";
import { FaSistrix } from "react-icons/fa";
import CreateTableComponent from "../share/CreateTableComponent";
import { NumberWithCommas } from "../share/NumberWithCommas";
import { FaWpforms } from "react-icons/fa";
import '../share/TabStyle.css'
import "../share/TableLanding.css";
import "../share/form.css";
import "./UserLogin.css";
import { CgClose } from "react-icons/cg";
import { BiReceipt } from "react-icons/bi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoMdCreate } from "react-icons/io";
import { HiOutlineDocumentPlus } from "react-icons/hi2";
import { MdEditCalendar } from "react-icons/md";
import { MdEditNote } from "react-icons/md";
import { getCustomStyles } from "../share/ModalStyle";
import { HiOutlineFolderDownload } from "react-icons/hi";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaFileExcel, FaFilePdf, FaVial, FaChalkboardTeacher } from "react-icons/fa";
import "./Modal.css"
import { SlNotebook } from "react-icons/sl";

export function TableLandingBorrowComponent() {
    const navigate = useNavigate();
    const myCustomStyles = getCustomStyles()
    const user = JSON.parse(localStorage.getItem("userData"));
    const [loading, setLoading] = useState(false);
    const [dataBorrow, setdataBorrow] = useState([]);
    const [getRemark, setGetRemark] = useState([]);
    const [getBorrowId, setGetBorrowId] = useState("");
    const [dataBorrowSix, setDataBorrowSix] = useState([]);
    const [dataExtendBorrow, setDataExtendBorrow] = useState([]);
    const [dataChangeBorrow, setDataChangeBorrow] = useState([]);
    const [disableButton, setDisableButton] = useState(false);
    const [showListSelectForm, setShowListSelectForm] = useState(false);
    const modalListFormToggle = () => setShowListSelectForm(!showListSelectForm)
    const [showRemarkData, setShowRemarkData] = useState(false);
    const modalShowRemarkDataToggle = () => setShowRemarkData(!showRemarkData)
    const [detailExtendAndChange, setDetailExtendAndChange] = useState(null);
    const [modalDetailExtendAndChange, setModalDetailExtendAndChange] = useState(false);
    const modalDetailExtendAndChangeToggle = () => setModalDetailExtendAndChange(!modalDetailExtendAndChange)

    //export ข้อมูลตำแหน่งงาน
    const [selectBorrowId, setSelectBorrowId] = useState(0)
    // console.log("selectBorrowId", selectBorrowId);
    const [modalExportJobposition, setModalExportJobposition] = useState(false);
    const modalExportJobpositionToggle = () => setModalExportJobposition(!modalExportJobposition);


    const [modalRemarkReason, setModalRemarkReason] = useState(false);
    const ToggleModalRemarkReason = () => setModalRemarkReason(!modalRemarkReason);

    const [remarkReasonData, setRemarkReasonData] = useState(null);
    const [remarkReasonLoading, setRemarkReasonLoading] = useState(false);

    const ExportJobposition = (borrowId) => {
        setSelectBorrowId(borrowId);
        modalExportJobpositionToggle();
    }
    const CallExportJobposition = React.forwardRef((props, ref) => {
        const { borrowId } = props;

        return (
            <div ref={ref} style={{ display: "inline" }}>

                <BsFillPersonVcardFill
                    className="mx-1 style-icon"
                    onClick={() => {
                        ExportJobposition(borrowId)
                    }}
                />
            </div>
        );
    });

    const fetchRemarkReason = async (borrowId) => {
        setRemarkReasonLoading(true);
        try {
            const postData = new FormData();
            postData.append("borrowId", Number(borrowId));

            const res = await fetch("/api/Borrow/getRemarkReason", {
                method: "POST",
                body: postData,
            });
            const resJson = await res.json();

            setRemarkReasonData(resJson?.dataenum ?? null);
            setModalRemarkReason(true);
        } catch (e) {
            // console.log("fetchRemarkReason error:", e);
        } finally {
            setRemarkReasonLoading(false);
        }
    };

    const RemarkReasonModal = () => {
        // ตัวช่วยแสดงรายการหมายเหตุให้ “ทนทาน” กับหลายโครงสร้าง
        const renderRemarkBlocks = () => {
            if (!remarkReasonData) {
                return <div className="text-center my-3">ไม่มีหมายเหตุ</div>;
            }

            // กรณีเป็น array ของรายการหมายเหตุ
            if (Array.isArray(remarkReasonData)) {
                if (!remarkReasonData.length) {
                    return <div className="text-center my-3">ไม่มีหมายเหตุ</div>;
                }
                return remarkReasonData.map((item, i) => {
                    const remarkText =
                        item?.remark ??
                        item?.remarkOfficer ??
                        item?.remarkDirector ??
                        item?.message ??
                        "-";
                    const by =
                        item?.byName ??
                        item?.createByName ??
                        item?.createdBy ??
                        item?.officerName ??
                        null;
                    const date =
                        item?.createDate ??
                        item?.createdDate ??
                        item?.remarkDate ??
                        item?.updatedAt ??
                        null;

                    return (
                        <div key={i} className="border border-1 p-3 mb-2 rounded">
                            <div className="mb-2">
                                <Label>หมายเหตุ</Label>
                                <div className="input-color">{remarkText}</div>
                            </div>
                            {(by || date) && (
                                <small className="text-muted">
                                    {by ? `โดย: ${by}` : null}
                                    {by && date ? " • " : null}
                                    {date ? `วันที่: ${date}` : null}
                                </small>
                            )}
                        </div>
                    );
                });
            }

            // กรณีเป็น string ธรรมดา
            if (typeof remarkReasonData === "string") {
                return (
                    <div className="border border-1 p-3 rounded">
                        <div className="input-color">{remarkReasonData}</div>
                    </div>
                );
            }

            // กรณีเป็น object: พยายามดึง key ที่ชื่อคล้าย remark
            const keys = Object.keys(remarkReasonData).filter(
                (k) => /remark/i.test(k) && remarkReasonData[k]
            );
            if (keys.length) {
                return keys.map((k, i) => (
                    <div key={i} className="border border-1 p-3 mb-2 rounded">
                        <Label>{k}</Label>
                        <div className="input-color">{String(remarkReasonData[k])}</div>
                    </div>
                ));
            }

            // fallback แสดง raw object (ไว้ดีบั๊ก)
            return (
                <pre className="border border-1 p-3 rounded">
                    {JSON.stringify(remarkReasonData, null, 2)}
                </pre>
            );
        };

        return (
            <Modal
                isOpen={modalRemarkReason}
                onRequestClose={ToggleModalRemarkReason}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h3
                        className="w-100"
                        style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}
                    >
                        หมายเหตุจากเจ้าหน้าที่กองส่งเสริม
                    </h3>
                    <CgClose onClick={ToggleModalRemarkReason} className="style-iconmodal" />
                </div>
                <hr />

                {remarkReasonLoading ? (
                    <Loading />
                ) : (
                    <div className="px-2">{renderRemarkBlocks()}</div>
                )}

                <div className="d-flex justify-content-center align-items-center mt-3">
                    <button
                        type="button"
                        className="btn-blue w-25"
                        onClick={ToggleModalRemarkReason}
                    >
                        ปิด
                    </button>
                </div>
            </Modal>
        );
    };

    const GetRemarkReason = React.forwardRef((props, ref) => {
        const { borrowId } = props;

        return (
            <div ref={ref} style={{ display: "inline" }}>

                <SlNotebook
                    className="mx-1 style-icon"
                    onClick={() => {
                        fetchRemarkReason(borrowId)
                    }}
                />
            </div>
        );
    });
    //ดึงข้อมูลการกู้ยืมเงิน
    useEffect(() => {
        async function getTdBorrow() {
            setLoading(true);
            try {
                let res = await fetch("/api/Borrow/listRequestBorrowing", {
                    method: "POST",
                    headers: {
                        // 'Content-type': 'application/json',
                        'token': user.token
                    }
                });
                const data = await res.json();
                setdataBorrow(data.dataenum);
            } catch (e) {
                // console.log("err =>" + e);
            } finally {
                setLoading(false);
            }
        }
        getTdBorrow()
    }, [])

    //ดึงข้อมูลการนำส่ง กย 6
    useEffect(() => {
        async function getBorrowSixByStatus() {
            setLoading(true)
            if (user.roldId === "3" || user.roldId === "4") {
                try {
                    let res = await fetch("/api/Borrow/getBorrowSixByStatus", {
                        method: "POST",
                        headers: {
                            // 'Content-type': 'application/json',
                            'token': user.token
                        }
                    })
                    let resJson = await res.json();
                    setDataBorrowSix(resJson.dataenum)
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false);
                }
            }
        }
        getBorrowSixByStatus()
    }, [])

    //ดึงข้อมูลการแจ้งเลื่อนการฝึกอบรม/ทดสอบฯ
    useEffect(() => {
        async function getBorrowExtendBorrow() {
            setLoading(true)
            let postData = new FormData()
            postData.append("roldId", user.roldId)
            postData.append("registerId", user.registerId)
            try {
                let res = await fetch("/api/ExtendAndChangeBorrow/getExtendBorrow", {
                    method: "POST",
                    headers: {
                        // 'Content-type': 'application/json',
                        'token': user.token
                    },
                    body: postData
                })
                let resJson = await res.json();

                if (user.roldId === "1" || user.roldId === "2") {
                    setDataExtendBorrow(resJson.dataenum.userTrainTests)

                } else if (user.roldId === "3" || user.roldId === "4") {
                    if (resJson.dataenum.length > 0) {
                        for (let i = resJson.dataenum.length - 1; i >= 0; i--) {
                            const data = resJson.dataenum[i];
                            if (!data.tdTrainNewsData.length && !data.tdTestNewsData.length) {
                                resJson.dataenum.splice(i, 1);
                            }
                        }
                    }
                    setDataExtendBorrow(resJson.dataenum)
                }

            } catch (e) {
                // console.log(e)
            } finally {
                setLoading(false);
            }
        }
        getBorrowExtendBorrow()
    }, [])

    //ดึงข้อมูลการเปลี่ยนแปลงหลักสูตรการฝึกอบรม/ทดสอบฯ
    useEffect(() => {
        async function getChangeBorrow() {
            setLoading(true)
            let postData = new FormData();
            postData.append("roldId", user.roldId)
            postData.append("registerId", user.registerId)
            try {
                let res = await fetch("/api/ExtendAndChangeBorrow/getChangeBorrow", {
                    method: "POST",
                    headers: {
                        // 'Content-type': 'application/json',
                        'token': user.token
                    },
                    body: postData
                })
                let resJson = await res.json();
                // console.log("resJson", resJson.dataenum)
                if (user.roldId === "4" || user.roldId === "3") {
                    if (resJson.dataenum.length > 0) {
                        for (let i = resJson.dataenum.length - 1; i >= 0; i--) {
                            const data = resJson.dataenum[i];
                            if (!data.tdTrainNewsData.length && !data.tdTestNewsData.length) {
                                resJson.dataenum.splice(i, 1);
                            }
                        }
                    }
                    setDataChangeBorrow(resJson.dataenum)
                } else if (user.roldId === "1" || user.roldId === "2") {
                    setDataChangeBorrow(resJson.dataenum.userTrainTests)
                }
            } catch (e) {
                // console.log(e)
            } finally {
                setLoading(false);
            }
        }
        getChangeBorrow()
    }, [])

    const ShowGetRemark = () => {
        return (
            <Modal
                isOpen={showRemarkData}
                onRequestClose={modalShowRemarkDataToggle}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>รายการที่ต้องดำเนินการแก้ไข</h3>
                    <CgClose onClick={modalShowRemarkDataToggle} className="style-iconmodal" />
                </div>
                <hr />
                {getRemark.map((remark, i) => (
                    <div key={i} className="d-flex flex-column">

                        {remark.remarkOfficer !== null ?
                            <div className="mt-3 w-100">
                                <Label>
                                    ความคิดเห็นสำหรับเจ้าหน้าที่ สพร./ สนพ.
                                </Label>
                                <div
                                    className="border border-1"
                                    style={{ minHeight: "3rem" }}
                                >
                                    <span className="input-color mx-1">{remark.remarkOfficer}</span>
                                </div>
                            </div>
                            : (
                                <div className="mt-3">
                                    <Label>
                                        ความคิดเห็นสำหรับเจ้าหน้าที่ สพร./ สนพ.
                                    </Label>
                                    <div
                                        className="border border-1"
                                        style={{ minHeight: "4rem" }}
                                    >
                                        <span className="input-color mx-1">-</span>
                                    </div>
                                </div>
                            )
                        }
                        {user.roldId === "3" ? (
                            <>
                                {remark.remarkDirector !== null ? (
                                    <>
                                        <div className="mt-3">
                                            <Label>
                                                ความคิดเห็นสำหรับผู้อำนวยการ
                                            </Label>
                                            <div
                                                className="border border-1"
                                                style={{ minHeight: "4rem" }}
                                            >
                                                <span className="input-color mx-1">{remark.remarkDirector}</span>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </>
                        ) : null}


                    </div>
                ))}
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        type="button"
                        style={{ backgroundColor: "#0A66C2", color: "#fff" }}
                        className="btn border border-1 w-25 rounded-pill mt-3"
                        onClick={modalShowRemarkDataToggle}>
                        ย้อนกลับ
                    </button>
                </div>

            </Modal>

        )
    };

    const getRemarkBorrowForm = async (borrowId) => {
        // console.log(typeof borrowId)
        let postData = new FormData();
        postData.append("borrowId", borrowId);
        try {
            let res = await fetch(`/api/Borrow/getRemarkBorrowForm/`, {
                method: "POST",
                body: postData
            })
            const resJson = await res.json()
            setGetRemark(resJson.dataenum);
            modalShowRemarkDataToggle()

        } catch (e) {
            // console.log("err =>", e)
        }
    };





    const ListSelectFormComponent = () => {
        // console.log("borrowId", getBorrowId)
        if (getBorrowId !== "") {
            return (
                <Modal
                    isOpen={showListSelectForm}
                    onRequestClose={modalListFormToggle}
                    style={myCustomStyles}
                >

                    <div className="d-flex justify-content-between align-items-center">
                        <h3 style={{ color: "#0E527E" }}>เลือกรายการ</h3>
                        <CgClose onClick={modalListFormToggle} className="style-iconmodal" />
                    </div>

                    <hr />

                    <div className="d-flex flex-wrap justify-content-center align-items-center ">
                        {user.roldId === "3" ?
                            <div className="d-flex">
                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/contact/signContact?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <FaSistrix className="icon-inmodal " />
                                        <span>รายละเอียดสัญญากู้ยืมเงิน</span>
                                    </div>

                                </button>
                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/borrow/borrowFollowEight?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <FaChalkboardTeacher className="icon-inmodal " />
                                        <span>ติดตามการฝึกอบรม/ดำเนินการทดสอบฯ (กย.8)</span>
                                    </div>
                                </button>
                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/invoice/CreateInvoiceBorrow?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <IoDocumentTextOutline className="icon-inmodal" />
                                        <span>จัดทำหนังสือสัญญาแจ้งหนี้</span>
                                    </div>

                                </button>
                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/contact/receivingDept?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <BiReceipt className="icon-inmodal" />
                                        <span>บันทึกการชำระเงิน</span>
                                    </div>
                                </button>


                            </div>

                            : null}

                        {user.roldId === "1" || user.roldId === "2" ? (
                            <div className="d-flex flex-column">
                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/borrow/borrowFollowSix?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <FaChalkboardTeacher className="icon-inmodal " />
                                        <span>บันทึกข้อมูลการติดตามประเมินผลการให้กู้ยืมเงิน (กย.6)</span>
                                    </div>

                                </button>

                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/extendBorrowCourseForm?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <MdEditCalendar className="icon-inmodal " />
                                        <span>แจ้งเลื่อนฝึกการฝึกอบรมหรือการทดสอบมาตรฐานฝีมือแรงงาน (กย.9)</span>
                                    </div>

                                </button>

                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/changeBorrowCourseForm?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <MdEditNote className="icon-inmodal " />
                                        <span>แจ้งเปลี่ยนแปลงหลักสูตรการฝึกอบรมหรือการทดสอบมาตรฐานฝีมือแรงงาน (กย.10)</span>
                                    </div>

                                </button>

                                <button
                                    type="button"
                                    className="modal-select"
                                    onClick={() => navigate(`/borrowing/contact/attatchFileBorrow?req=${getBorrowId}`)}
                                >
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <BiReceipt className="icon-inmodal" />
                                        <span>แนบหลักฐานสำเนาบัตรประชาชนคู่สมรส และ ทะเบียนสมรส</span>
                                    </div>

                                </button>

                            </div>
                        ) : null}

                        <div className="d-flex align-items-center justify-content-center w-100 mt-3  mb-3">
                            <button onClick={modalListFormToggle} className="btn-blue p-2 w-25">ย้อนกลับ</button>
                        </div>

                    </div>
                </Modal>
            );
        } else {
            return;
        }

    };

    const callListSelectForm = (borrowId) => {
        setGetBorrowId(borrowId)
        modalListFormToggle()
    }

    //ปุ่ม export ที่ใช้ tooltip
    const CallExportSupportForm = React.forwardRef((props, ref) => {
        const { borrowId } = props;
        return (
            <div ref={ref} style={{ display: "inline" }}>
                <HiOutlineFolderDownload
                    className="mx-1 style-icon"
                    onClick={() => {
                        window.open(`api/Borrow/exportBorrowForm/${borrowId}`)
                    }}
                />
            </div>
        );
    });

    //tab กย6
    const BORROWSIXCOLUMNS = [
        {
            Header: "เลขที่อ้างอิง",
            accessor: "borrowId",
        },
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
            enableRowSpan: true,
        },

        {
            Header: "ชื่อ",
            accessor: "employee",
        },

        {
            Header: "เลขที่คำขอ",
            accessor: "borrowNumber",
            Cell: ({ row, value }) => {
                if (value === null) {
                    return (
                        <div>-</div>
                    )
                } else {
                    return (
                        <>{value}</>
                    )
                }
            }
        },

        {
            Header: "สถานะ",
            accessor: "resultTrainTestAll",
            Cell: ({ row, value }) => {
                if (value === "PASS" && row.original.find === "send") {
                    return (
                        <>
                            ส่งแล้ว
                            <FaSistrix
                                className="mx-3 style-icon"
                                onClick={() =>
                                    navigate(
                                        `/borrowing/borrow/checkBorrowFollowSix?req=${row.original.borrowId}`
                                    )
                                }
                            />
                        </>
                    )

                } else if (value === "PASS" && row.original.find === "notSend") {
                    return (
                        <>
                            อบรม/ทดสอบฯเสร็จแล้ว แต่ยังไม่ส่งรายงาน
                        </>
                    )

                } else {
                    return (
                        <>
                            {/* ยังอบรมไม่เสร็จ */}
                            ส่งแล้ว
                            <FaSistrix
                                className="mx-3 style-icon"
                                onClick={() =>
                                    navigate(
                                        `/borrowing/borrow/checkBorrowFollowSix?req=${row.original.borrowId}`
                                    )
                                }
                            />
                        </>
                    )
                }
            }
        },

    ]

    // export เอกสารแบบฟอร์มชอรับเงินช่วยเหลือหรืออุดหนุน
    const ModalExportJobPosition = () => {
        return (
            <Modal
                isOpen={modalExportJobposition}
                onRequestClose={modalExportJobpositionToggle}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "700px" }}>
                        เลือกรายการ
                    </h3>
                </div>
                <hr />

                <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3 px-3">
                    {/* ฝึกอบรม Excel */}
                    <button
                        type="button"
                        style={{ maxWidth: 320, width: "100%" }}
                        className="modal-select export-card bg-excel-gradient position-relative"
                        onClick={() => window.open(`api/BorrowRegis/export/exportJobPosition/${selectBorrowId}/1`)}
                    // onClick={() => window.open(`api/...`)}
                    >
                        <div className="badge-file d-flex align-items-center gap-1">
                            <FaFileExcel className="me-1" /> Excel
                        </div>
                        {/* <div className="export-icon-lg mb-2"><FaChalkboardTeacher /></div> */}
                        <div className="export-title text-center">ข้อมูลตำแหน่งงานการฝึกอบรม</div>
                    </button>

                    {/* ฝึกอบรม PDF */}
                    <button
                        type="button"
                        style={{ maxWidth: 320, width: "100%" }}
                        className="modal-select export-card bg-pdf-gradient position-relative"
                        onClick={() => window.open(`api/BorrowRegis/export/exportJobPosition/${selectBorrowId}/2`)}

                    // onClick={() => window.open(`api/BorrowRegis/export/exportJobPosition/261/2`)}

                    >
                        <div className="badge-file d-flex align-items-center gap-1">
                            <FaFilePdf className="me-1" /> PDF
                        </div>
                        {/* <div className="export-icon-lg mb-2"><FaChalkboardTeacher /></div> */}
                        <div className="export-title text-center">ข้อมูลตำแหน่งงานการฝึกอบรม</div>
                    </button>

                    {/* การทดสอบ Excel */}
                    <button
                        type="button"
                        style={{ maxWidth: 320, width: "100%" }}
                        className="modal-select export-card bg-excel-gradient position-relative"
                    >
                        <div className="badge-file d-flex align-items-center gap-1">
                            <FaFileExcel className="me-1" /> Excel
                        </div>
                        {/* <div className="export-icon-lg mb-2"><FaVial /></div> */}
                        <div className="export-title text-center">ข้อมูลตำแหน่งงานการทดสอบฯ</div>
                    </button>

                    {/* การทดสอบ PDF */}
                    <button
                        type="button"
                        style={{ maxWidth: 320, width: "100%" }}
                        className="modal-select export-card bg-pdf-gradient position-relative"
                    >
                        <div className="badge-file d-flex align-items-center gap-1">
                            <FaFilePdf className="me-1" /> PDF
                        </div>
                        {/* <div className="export-icon-lg mb-2"><FaVial /></div> */}
                        <div className="export-title text-center">ข้อมูลตำแหน่งงานการทดสอบฯ</div>
                    </button>
                </div>
            </Modal>
        );
    };
    //tab คำขอเงินกู้ยืม
    const ShowInfoByUsers = () => {
        // กรณี user เป็นบุคคลธรรมดาหรือนิติบุคคล

        if (user.roldId === "1" || user.roldId === "2") {
            const COLUMNS = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1,
                    enableRowSpan: true,
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                    // Cell: ({ value }) => {
                    //   return format(new Date(value), "dd/MM/yyyy");
                    // },
                },
                {
                    Header: "วงเงินที่ขอกู้",
                    accessor: "amountLimit",
                    Cell: ({ value }) => {
                        return <>{NumberWithCommas(value)} บาท</>;
                    },
                },
                {
                    Header: "วงเงินที่อนุมัติ",
                    accessor: "approveAmount",
                    Cell: ({ value }) => {
                        return <>{NumberWithCommas(value)} บาท</>;
                    },
                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",
                },
                {
                    Header: "รายละเอียด",
                    accessor: "borrowStatusId",
                    Cell: ({ row, value }) => {
                        if (value === "1") {
                            // อยู่ระหว่างจัดทำ
                            // console.log(row)
                            return (
                                <>
                                    {row.original.borrowStatusName}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/BorrowForm?req=${row.original.borrowId}&&status=${row.original.borrowStatusId}`
                                            )
                                        }
                                    />
                                </>
                            );
                        } else if (value === "2") {
                            // รอเจ้าหน้าที่รับเรื่อง
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "4") {
                            // มีการแก้ไข
                            return (
                                <>
                                    {row.original.borrowStatusName}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/BorrowForm?req=${row.original.borrowId}&&status=${row.original.borrowStatusId}`
                                            )
                                        }
                                    />
                                    {/* <button type="button" onClick={()=> getRemarkBorrowForm(row.original.borrowId)}>ดูรายการที่ต้องแก้ไข</button> */}
                                    <FaSistrix className="mx-1 style-icon"
                                        onClick={() => getRemarkBorrowForm(row.original.borrowId)}
                                    />
                                </>
                            );
                        } else if (value === "5") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "7") {
                            return (
                                <>
                                    {/* {row.original.borrowStatusId} */}
                                    มีการแก้ไข
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/BorrowForm?req=${row.original.borrowId}&&status=${row.original.borrowStatusId}`
                                            )
                                        }
                                    />
                                    <FaSistrix className="mx-1 style-icon"
                                        onClick={() => getRemarkBorrowForm(row.original.borrowId)}
                                    />
                                </>
                            );
                        } else if (value === "12") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "13") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "14") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "15") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "16") {
                            return (
                                <>
                                    {row.original.borrowStatusName}
                                    <FaWpforms
                                        className="mx-3 style-icon"
                                        onClick={() => {
                                            callListSelectForm(row.original.borrowId)
                                        }}
                                    />

                                </>
                            );
                        } else if (value === "17") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "18") {
                            return <>{row.original.borrowStatusName}</>;
                        } else if (value === "19") {
                            return <>{row.original.borrowStatusName}</>;
                        } else {
                            return <>อยู่ระหว่างตรวจสอบ</>;
                        }
                    },
                },
            ];
            return COLUMNS;
        } else if (user.roldId === "3") {
            const COLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",

                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",

                },
                {
                    Header: "ชื่อ",
                    accessor: "employee",
                },
                {
                    Header: "วงเงินที่ขอกู้",
                    accessor: "amountLimit",
                    Cell: ({ value }) => {
                        return <>{NumberWithCommas(value)} บาท</>;
                    },
                },
                // {
                //   Header: "วงเงินที่อนุมัติ",
                //   accessor: "approveAmount",
                //   Cell: ({ value }) => {
                //     return <>{NumberWithCommas(value)} บาท</>;
                //   },
                // },
                {
                    Header: "ประเภท",
                    accessor: "borrowTypeName",
                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "borrowNumber",
                },
                {
                    Header: "รายละเอียด",
                    accessor: "borrowStatusId",
                    Cell: ({ row, value }) => {
                        if (value === "1") {
                            return (
                                <>
                                    {row.original.borrowStatusName}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/create-borrowing?req=${row.original.borrowId}&&status=${row.original.borrowStatusId}`
                                            )
                                        }
                                    />
                                </>
                            );
                        }
                        if (value === "2") {
                            return (
                                <>
                                    {row.original.borrowStatusName}

                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check?req=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                </>
                            );
                        } else if (value === "4") {
                            return (
                                <>อยู่ระหว่างการแก้ไข</>
                            )

                        } else if (value === "5") {
                            return (
                                <>
                                    {row.original.borrowStatusName}

                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check?req=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                </>
                            );
                        } else if (value === "6") {
                            return <>
                                {row.original.borrowStatusName}
                                <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                    <CallExportJobposition borrowId={row.original.borrowId} />
                                </Tippy></>;
                        } else if (value === "7") {
                            return <>{row.original.borrowStatusName}
                                <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                    <CallExportJobposition borrowId={row.original.borrowId} />
                                </Tippy></>;
                        } else if (value === "8") {
                            return <>{row.original.borrowStatusName} <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                <CallExportJobposition borrowId={row.original.borrowId} />
                            </Tippy></>;
                        } else if (value === "13") {
                            return <>{row.original.borrowStatusName} </>;
                        } else if (value === "11") {
                            return (
                                <>
                                    {/* ทดสอบบบ */}
                                    {row.original.borrowStatusName}
                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check?req=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                    <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                        <CallExportJobposition borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <button type="button" onClick={() => getRemarkBorrowForm(row.original.borrowId)} className="mx-1 btn-blue">ดูความเห็น</button>

                                </>
                            );
                        } else if (value === "14") {
                            return (
                                <div className="d-flex justify-content-between align-items-center">
                                    {row.original.borrowStatusName}

                                    <Tippy content="ดาวน์โหลดเอกสารคำขอกู้ยืมเงิน">
                                        <CallExportSupportForm borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                        <CallExportJobposition borrowId={row.original.borrowId} />
                                    </Tippy>

                                    <Tippy content="หมายเหตุจากเจ้าหน้าที่กองส่งเสริม">
                                        <GetRemarkReason borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <button
                                        className="btn-green"
                                        onClick={() => navigate(`/borrowing/contact/signContact?req=${row.original.borrowId}`)}
                                    >
                                        <HiOutlineDocumentPlus />
                                        จัดทำสัญญากู้ยืมเงิน

                                    </button>


                                </div>
                            );
                        } else if (value === "16") {
                            return (
                                <>
                                    {row.original.borrowStatusName}
                                    <FaWpforms
                                        className="mx-3 style-icon"
                                        onClick={() => {
                                            callListSelectForm(row.original.borrowId)
                                        }}
                                    />
                                    <Tippy content="หมายเหตุจากเจ้าหน้าที่กองส่งเสริม">
                                        <GetRemarkReason borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <Tippy content="ดาวน์โหลดเอกสารคำขอกู้ยืมเงิน">
                                        <CallExportSupportForm borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                        <CallExportJobposition borrowId={row.original.borrowId} />
                                    </Tippy>

                                </>
                            );
                        } else if (value === "10") {
                            return (
                                <>
                                    อยู่ระหว่างการดําเนินการ
                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check?req=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                    <Tippy content="ดาวน์โหลดเอกสารคำขอกู้ยืมเงิน">
                                        <CallExportSupportForm borrowId={row.original.borrowId} />
                                    </Tippy>
                                    <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                        <CallExportJobposition borrowId={row.original.borrowId} />
                                    </Tippy>
                                </>
                            );
                        }
                    },
                },
            ];
            return COLUMNS;
        } else if (user.roldId === "4") {
            const COLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",
                },

                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },
                {
                    Header: "ชื่อ",
                    accessor: "employee",
                },
                {
                    Header: "วงเงินที่ขอกู้",
                    accessor: "amountLimit",
                    Cell: ({ value }) => {
                        return <>{NumberWithCommas(value)} บาท</>;
                    },
                },
                {
                    Header: "ประเภท",
                    accessor: "borrowTypeName",

                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "borrowNumber",
                    Cell: ({ row, value }) => {
                        if (value === "" || value === null || value === undefined) {
                            return (
                                <div>-</div>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "รายละเอียด",
                    // accessor: "borrowStatusId",
                    accessor: "borrowStatusName",
                    Cell: ({ row, value }) => {
                        return (
                            <>
                                {value}
                                {row.original.borrowStatusId === "10" ? (
                                    <FaSistrix
                                        className="style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check?req=${row.original.borrowId}`
                                            )
                                        }
                                    />

                                ) : null}

                                {row.original.borrowStatusId === "12" ? (
                                    <FaSistrix
                                        className=" style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/check/detail?id=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                ) : null}

                                {row.original.borrowStatusId === "14" ? (
                                    <FaSistrix
                                        className="ms-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/borrowing/admin/approve?req=${row.original.borrowId}`
                                            )
                                        }
                                    />
                                ) : null}

                                <Tippy content="ดาวน์โหลดเอกสารคำขอกู้ยืมเงิน">
                                    <CallExportSupportForm borrowId={row.original.borrowId} />
                                </Tippy>
                                <Tippy content="ดาวน์โหลดเอกสารข้อมูลตำแหน่งงาน">
                                    <CallExportJobposition borrowId={row.original.borrowId} />
                                </Tippy>
                            </>
                        )
                    },
                },
            ];
            return COLUMNS;
        }
    };

    const getDataExtendOrChangeByType = async (id, type) => {
        // console.log("id", id)
        let postData = new FormData()
        postData.append("traintestId", id)
        postData.append("type", type)
        try {
            let res = await fetch("/api/ExtendAndChangeBorrow/getDataExtendOrChangeByType", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();
            setDetailExtendAndChange(resJson.dataenum)
        } catch (e) {
            // console.log(e)
        } finally {
            modalDetailExtendAndChangeToggle()
        }
    }
    const DetailExtendOrChange = () => {
        if (detailExtendAndChange !== null) {
            return (
                <Modal
                    isOpen={modalDetailExtendAndChange}
                    onRequestClose={modalDetailExtendAndChangeToggle}
                    style={myCustomStyles}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 style={{ color: "#0E527E" }}>รายละเอียด</h3>
                        <CgClose onClick={modalDetailExtendAndChangeToggle} className="style-iconmodal" />
                    </div>

                    <div className="px-3 mt-3">
                        <p className="input-color text-white text-center" style={{ backgroundColor: "#0A66C2", lineHeight: "2.5rem" }}>ข้อมูลเดิม</p>
                        <div className="border border-1 p-3 mb-2">
                            <span className="input-color">{detailExtendAndChange?.oldCourseLawOccupationName} {detailExtendAndChange?.classTimeId}</span>
                            {detailExtendAndChange?.classTimeId !== null ? (
                                <>
                                    <div>วันที่เริ่มฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.startDate}</span></div>
                                    <div>วันที่สิ้นสุดฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.endDate}</span></div>
                                    <div>ที่อยู่สถานที่ดำเนินการฝึกอบรม / ทดสอบฯ</div>
                                    <div className="p-1">
                                        <div>สถานที่ดำเนินการฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.locationName}</span></div>
                                        <span className="">
                                            เลขที่
                                            <span className="input-color mx-1">
                                                {detailExtendAndChange?.addressNo ?? "-"}
                                            </span>
                                        </span>
                                        <span className="mx-1">หมู่ <span className="input-color mx-1">{detailExtendAndChange?.moo ?? "-"}</span></span>
                                        <span>ซอย<span className="input-color mx-1">{detailExtendAndChange?.soi ?? "-"}</span></span>
                                        <span className="mx-1">ถนน <span className="mx-1 input-color">{detailExtendAndChange?.street ?? "-"}</span></span>
                                        <span className="mx-1">ตำบล<span className="input-color mx-1">{detailExtendAndChange?.tumbonName ?? "-"}</span></span>
                                        <span className="mx-1">อำเภอ <span className="input-color mx-1">{detailExtendAndChange?.amphurName ?? "-"}</span></span>
                                        <span className="">จังหวัด <span className="input-color mx-1">{detailExtendAndChange?.provinceName ?? "-"}</span> </span>
                                        <span>รหัสไปรษณีย์ <span className="mx-1 input-color">{detailExtendAndChange?.postCode ?? "-"}</span></span>
                                        <span>เบอร์โทรศัพท์<span className="input-color mx-1"> {detailExtendAndChange?.phone ?? "-"}</span></span>
                                        <span>โทรสาร<span className="input-color mx-1">{detailExtendAndChange?.fax ?? "-"}</span></span>
                                        <span>โทรศัพท์มือถือ<span className="input-color mx-1">{detailExtendAndChange?.mobile ?? "-"}</span></span>
                                        <span>อีเมล์<span className="input-color mx-1">{detailExtendAndChange?.email ?? "-"}</span></span>
                                    </div>
                                </>
                            ) : null}


                        </div>

                        <p className="input-color text-white text-center" style={{ backgroundColor: "#0A66C2", lineHeight: "2.5rem" }}>รายการที่ขอแจ้งเลื่อนหรือเปลี่ยนแปลงการฝึกอบรม/ทดสอบฯ</p>
                        <div className="border border-1 p-3 mb-2">
                            <span className="input-color">{detailExtendAndChange?.courseLawOccupationName ?? null}</span>
                            {detailExtendAndChange?.classTimeId !== null ? (
                                <>
                                    <div>วันที่เริ่มฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.newStartDate ?? "-"}</span></div>
                                    <div>วันที่สิ้นสุดฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.newEndDate ?? "-"}</span></div>
                                    <div>ที่อยู่สถานที่ดำเนินการฝึกอบรม / ทดสอบฯ</div>
                                    <div className="p-1">
                                        <div>สถานที่ดำเนินการฝึกอบรม / ทดสอบฯ :<span className="input-color"> {detailExtendAndChange?.newLocationName ?? "-"}</span></div>
                                        <span className="">
                                            เลขที่
                                            <span className="input-color mx-1">
                                                {detailExtendAndChange?.newAddressNo ?? "-"}
                                            </span>
                                        </span>
                                        <span className="mx-1">หมู่ <span className="input-color mx-1">{detailExtendAndChange?.newMoo ?? "-"}</span></span>
                                        <span>ซอย<span className="input-color mx-1">{detailExtendAndChange?.newSoi ?? "-"}</span></span>
                                        <span className="mx-1">ถนน <span className="mx-1 input-color">{detailExtendAndChange?.newStreet ?? "-"}</span></span>
                                        <span className="mx-1">ตำบล<span className="input-color mx-1">{detailExtendAndChange?.newTumbonName ?? "-"}</span></span>
                                        <span className="mx-1">อำเภอ <span className="input-color mx-1">{detailExtendAndChange?.newAmphurName ?? "-"}</span></span>
                                        <span className="">จังหวัด <span className="input-color mx-1">{detailExtendAndChange?.newProvinceName ?? "-"}</span> </span>
                                        <span>รหัสไปรษณีย์ <span className="mx-1 input-color">{detailExtendAndChange?.newPostCode ?? "-"}</span></span>
                                        <span>เบอร์โทรศัพท์<span className="input-color mx-1"> {detailExtendAndChange?.newPhone ?? "-"}</span></span>
                                        <span>โทรสาร<span className="input-color mx-1">{detailExtendAndChange?.newFax ?? "-"}</span></span>
                                        <span>โทรศัพท์มือถือ<span className="input-color mx-1">{detailExtendAndChange?.newMobile ?? "-"}</span></span>
                                        <span>อีเมล์<span className="input-color mx-1">{detailExtendAndChange?.newEmail ?? "-"}</span></span>
                                    </div>
                                </>
                            ) : null}

                        </div>
                    </div>
                </Modal>
            )
        }
    }
    const ShowExtendByUser = () => {
        if (user.roldId === "1" || user.roldId === "2") {
            const EXTENDBORROWCOLUMNS = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1,
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },
                {
                    Header: "ชื่อหลักสูตร /สาขาอาชีพ",
                    accessor: "courseLawOccupation",
                },
                {
                    Header: "รุ่นที่ / ครั้งที่",
                    accessor: "classTime",
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ value, row }) => {
                        return (
                            <>
                                {value === null ? "รอเจ้าหน้าที่ตรวจสอบ" : null}
                                {value === "17" ? "ผ่านการตรวจสอบจาก สพร./สนพ." : null}
                                {value === "13" ? "ไม่อนุมัติ" : null}
                                {value === "20" ? "อนุมัติ" : null}
                                {value === "21" ? "ไม่อนุมัติ" : null}
                                <FaSistrix className="mx-1 style-icon"
                                    onClick={() => getDataExtendOrChangeByType(row.original.id, row.original.type)}
                                />
                            </>
                        )
                    },
                },
            ]
            return EXTENDBORROWCOLUMNS;

        } else if (user.roldId === "3") {
            //tab แจ้งเลื่อน
            const EXTENDBORROWCOLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",
                },
                {
                    Header: "ชื่อ",
                    accessor: "employee",
                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "borrowNumber",
                    Cell: ({ row, value }) => {
                        if (value === null) {
                            return (
                                <div>-</div>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ row, value }) => {
                        // console.log(row.original)
                        if (row.original.tdTestNewsData.length > 0) {
                            // console.log(row.original)
                            if (row.original.tdTestNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() =>
                                                navigate(
                                                    `/borrowing/ExtendBorrowCheck?req=${row.original.borrowId}&trainTestId=${row.original.trainTestId}`
                                                )
                                            }
                                        />
                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "17") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "20") {
                                return (
                                    <>
                                        อนุมัติ
                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่อนุมัติ
                                    </>
                                )
                            }
                        } else if (row.original.tdTrainNewsData.length > 0) {
                            if (row.original.tdTrainNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() =>
                                                navigate(
                                                    `/borrowing/ExtendBorrowCheck?req=${row.original.borrowId}&trainTestId=${row.original.trainTestId}`
                                                )
                                            }
                                        />
                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "17") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "20") {
                                return (
                                    <>
                                        เห็บชอบ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่เห็บชอบ

                                    </>
                                )
                            }
                        }
                    }
                }

            ]
            return EXTENDBORROWCOLUMNS
        } else if (user.roldId === "4") {
            //tab แจ้งเลื่อน
            const EXTENDBORROWCOLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",
                },
                {
                    Header: "ชื่อ",
                    accessor: "employee",
                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "borrowNumber",
                    Cell: ({ row, value }) => {
                        if (value === null) {
                            return (
                                <div>-</div>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ row, value }) => {
                        // console.log(row.original)
                        if (row.original.tdTestNewsData.length > 0) {
                            // console.log(row.original)
                            if (row.original.tdTestNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "17") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "20") {
                                return (
                                    <>
                                        อนุมัติ
                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่อนุมัติ
                                    </>
                                )
                            }
                        } else if (row.original.tdTrainNewsData.length > 0) {
                            if (row.original.tdTrainNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "17") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "20") {
                                return (
                                    <>
                                        เห็บชอบ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่เห็บชอบ

                                    </>
                                )
                            }
                        }
                    }
                }

            ]
            return EXTENDBORROWCOLUMNS
        }
    }
    //tab แจ้งเปลี่ยนแปลง
    const ShowChangeBorrowTrainTests = () => {
        if (user.roldId === "3" || user.roldId === "4") {
            const CHANGEBORROWCOLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "borrowId",
                },
                {
                    Header: "ชื่อ",
                    accessor: "employee",
                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "borrowNumber",
                    Cell: ({ row, value }) => {
                        if (value === null) {
                            return (
                                <div>-</div>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ row, value }) => {

                        if (row.original?.tdTestNewsData?.length > 0) {
                            // console.log(row.original.tdTestNewsData)
                            if (row.original.tdTestNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() =>
                                                navigate(
                                                    `/borrowing/ChangeBorrowCheck?req=${row.original.borrowId}`
                                                )
                                            }
                                        />
                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "18") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "20") {
                                return (
                                    <>
                                        เห็บชอบ

                                    </>
                                )
                            } else if (row.original.tdTestNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่เห็บชอบ

                                    </>
                                )
                            }
                        } else if (row.original.tdTrainNewsData.length > 0) {
                            if (row.original.tdTrainNewsData[0].status === null) {
                                return (
                                    <>
                                        รอเจ้าหน้าที่ตรวจสอบ
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() =>
                                                navigate(
                                                    `/borrowing/ChangeBorrowCheck?req=${row.original.borrowId}`
                                                )
                                            }
                                        />
                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "18") {
                                return (
                                    <>
                                        ผ่านการตรวจสอบจาก สพร./สนพ.

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "13") {
                                return (
                                    <>
                                        ไม่อนุมัติ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "20") {
                                return (
                                    <>
                                        เห็บชอบ

                                    </>
                                )
                            } else if (row.original.tdTrainNewsData[0].status === "21") {
                                return (
                                    <>
                                        ไม่เห็บชอบ

                                    </>
                                )
                            }
                        }
                    }
                }
            ]
            return CHANGEBORROWCOLUMNS;
        } else if (user.roldId === "1" || user.roldId === "2") {
            const CHANGEBORROWCOLUMNS = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1,
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },
                {
                    Header: "หลักสูตรเดิม / สาขาอาชีพเดิม",
                    accessor: "courseLawOccupation",
                },
                {
                    Header: "หลักสูตรใหม่ / สาขาอาชีพใหม่",
                    accessor: "newCourseLawOccupation",
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ value, row }) => {
                        return (
                            <>
                                {value === null ? "รอเจ้าหน้าที่ตรวจสอบ" : null}
                                {value === "18" ? "ผ่านการตรวจสอบจาก สพร./สนพ." : null}
                                {value === "13" ? "ไม่อนุมัติ" : null}
                                {value === "20" || value === "21" ? "รอเจ้าหน้าที่ตรวจสอบ" : null}
                                {/* <FaSistrix className="mx-1 style-icon"
                      onClick={() => getDataExtendOrChangeByType(row.original.id, row.original.type)}
                    /> */}
                            </>
                        )
                    },
                },
            ]
            return CHANGEBORROWCOLUMNS
        }
    }

    const FormButton = () => {
        // console.log("user", user);
        if (user.roldId === "1" || user.roldId === "2") {
            if (dataBorrow.map((data) => (
                Object.entries(data).forEach(([key]) => {
                    if (key.endsWith("StatusId")) {
                        if (data[key] !== "19" && data[key] !== "13") {
                            setDisableButton(true)
                        } else {
                            return;
                        }
                    }
                })
            )))
                return (
                    <button
                        className="btn-blue create-button-form"
                        disabled={disableButton}
                        onClick={() => navigate(`/borrowing/BorrowForm?req=0&&status=0`)}
                    >
                        <IoMdCreate className="mx-2" />
                        สร้างแบบคำขอกู้ยืมเงิน
                    </button>
                );
        } else if (user.roldId == "3") {
            return (
                <button
                    className="btn-blue create-button-form"
                    // disabled={disableButton}
                    onClick={() => navigate(`/borrowing/create-borrowing?req=0&&status=0`)}
                >
                    <IoMdCreate className="mx-2" />
                    สร้างแบบคำขอกู้ยืมเงิน
                </button>
            );
        }
        return;
    };
    if (loading) { return <Loading /> }
    return (
        <Container className="mt-4 mb-2">
            <Tabs>
                <TabList className="d-flex align-items-center justify-content-center flex-wrap">
                    <Tab>รายการคำขอกู้ยืมเงิน</Tab>
                    {user.roldId === "3" || user.roldId === "4" ? <Tab>รายงานการส่งแบบ กย.6</Tab> : null}
                    <Tab>รายการแจ้งเลื่อนการฝึกอบรม/การทดสอบฯ</Tab>
                    <Tab>รายการแจ้งเปลี่ยนแปลงการฝึกอบรม/การทดสอบฯ</Tab>

                </TabList>
                <TabPanel>
                    <CreateTableComponent
                        column={ShowInfoByUsers()}
                        dataInput={dataBorrow}
                        FormInput={FormButton}
                        showEntrie={true}
                        showPage={true}
                    />
                </TabPanel>
                {user.roldId === "3" || user.roldId === "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={BORROWSIXCOLUMNS}
                            dataInput={dataBorrowSix}
                            // FormInput={FormButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null}


                <TabPanel>
                    <CreateTableComponent
                        column={ShowExtendByUser()}
                        dataInput={dataExtendBorrow}
                        showEntrie={true}
                        showPage={true}
                    />
                </TabPanel>

                <TabPanel>
                    <CreateTableComponent
                        column={ShowChangeBorrowTrainTests()}
                        dataInput={dataChangeBorrow}
                        showEntrie={true}
                        showPage={true}
                    />
                </TabPanel>
            </Tabs>
            <ListSelectFormComponent />
            <ShowGetRemark />
            <DetailExtendOrChange />
            <ModalExportJobPosition />
            <RemarkReasonModal />

            {/* <ModalExportJobPosition /> */}

            {/* <SignContact /> */}
            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>

    );
}
